/**
 * Manufacturing API
 * Manufacturing API
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 0 = None, 1 = Generated, 2 = Scanned
 */
export enum ScannableCodeSource {
    None = 0,
    Generated = 1,
    Scanned = 2
}

